import { Col, Form, InputNumber, Row } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import React, { FunctionComponent } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { inputNumberFormatter } from '../../utils/buybackHelpers'

const gutter: Gutter | [Gutter, Gutter] = [16, 16]

export const BuybackFormFinancingSetting: FunctionComponent = () => {
  return (
    <Row gutter={gutter}>
      <Col xs={24} md={6}>
        <Form.Item label="Úrok investora (p.a.)" name={FIELD.InvestorRate}>
          <InputNumber
            min={-50}
            max={50}
            step={0.5}
            precision={1}
            className="w-full"
            addonAfter="%"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          label="Tržní růst nemovitosti (rok)"
          name={FIELD.MarketPriceAnnualGrowth}
        >
          <InputNumber
            min={-50}
            max={50}
            step={0.5}
            precision={1}
            className="w-full"
            addonAfter="%"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item label="Náklady tržního prodeje" name={FIELD.MarketSaleCosts}>
          <InputNumber
            min={0}
            max={50}
            step={0.5}
            precision={1}
            className="w-full"
            addonAfter="%"
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          label="Doba potřebná k tržnímu prodeji"
          name={FIELD.MarketSaleDurationMonths}
        >
          <InputNumber
            min={0}
            max={24}
            step={1}
            className="w-full"
            addonAfter="měs."
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item name={FIELD.RentDurationMonths} label="Délka nájmu">
          <InputNumber
            min={0}
            step={1}
            max={120}
            className="w-full"
            addonAfter="měs."
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item name={FIELD.RentPrice} label="Sjednaná výše nájemného">
          <InputNumber
            min={0}
            step={100}
            className="w-full"
            formatter={inputNumberFormatter}
            addonAfter="Kč"
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          name={FIELD.BuybackPrice}
          label="Garant. výše zpětného odkupu"
        >
          <InputNumber
            min={0}
            step={1000}
            formatter={inputNumberFormatter}
            addonAfter="Kč"
            className="w-full"
          />
        </Form.Item>

        <Form.Item name={FIELD.BaseBuybackPrice} hidden>
          <InputNumber />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item label="Cenová nabídka výkupu nemovitosti">
          <div className="flex space-x-4">
            <Form.Item
              name={FIELD.OfferPercentage}
              className="w-1/2 !mb-0 !bg-gray-50"
            >
              <InputNumber
                min={55}
                step={0.1}
                className="w-full"
                addonAfter="%"
              />
            </Form.Item>

            <Form.Item
              name={FIELD.OfferPrice}
              className="w-1/2 !mb-0 !bg-gray-50"
            >
              <InputNumber
                min={0}
                step={100_000}
                className="w-full"
                formatter={inputNumberFormatter}
                addonAfter="Kč"
                disabled
              />
            </Form.Item>
          </div>
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item label="Roční navýšení zpětného odkupu">
          <div className="flex space-x-4">
            <Form.Item
              name={FIELD.AnnualInterestRate}
              className="w-1/2 !mb-0 !bg-gray-50"
            >
              <InputNumber
                min={0}
                step={0.1}
                className="w-full"
                addonAfter="%"
              />
            </Form.Item>

            <Form.Item
              name={FIELD.AnnualInterestPrice}
              className="w-1/2 !mb-0 !bg-gray-50"
            >
              <InputNumber
                min={0}
                step={100_000}
                className="w-full"
                formatter={inputNumberFormatter}
                addonAfter="Kč"
                disabled
              />
            </Form.Item>
          </div>
        </Form.Item>
      </Col>
    </Row>
  )
}
